<template>
  <div class="group-manager-report">
    <!-- Header del Reporte -->
    <v-card class="mb-6">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" class="mr-3">mdi-account-group</v-icon>
        <span class="text-h5">Reporte Group Manager</span>
      </v-card-title>

      <v-card-text>
        <h6 class="text-subtitle-1 font-weight-bold">Manager: {{ managerInfo.name }}</h6>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>
        <v-icon color="primary" class="mr-2">mdi-chart-box-outline</v-icon>
        Rendimiento del grupo
      </v-card-title>
      <!--
        P13-V5A-R5 · RETIRED. Esta página nunca emitió una petición. `loadReportData()`
        asignaba literales: eficiencia grupal 87 %, 8 supervisores (7 activos), 156
        incidencias con tendencia -8 % y proyección de mejora 15 %; y sobre esos literales
        construía un padrón de SIETE supervisores inventados con nombre propio, su carga de
        trabajo, un ranking de "Top Performers", una tabla de detalle por supervisor con
        última actividad, metas mensuales y "acciones recomendadas" que nombraban a esas
        personas. Su única referencia a un backend era el comentario
        `En producción: ApiClient.get('/api/reports/group-manager/:id')`: ese endpoint no
        existe en el backend (main 38d3779b), donde `/api/reports/*` sólo monta
        `/api/reports/organizational` (app.js:568). También se retiran los dos gráficos
        Chart.js, que graficaban exactamente esos literales; el selector de rango de fechas,
        cuya única función era volver a asignarlos; el nombre de grupo fijo "Grupo Regional
        Norte" del encabezado, que no procedía de ninguna lectura; y el botón "Exportar", que
        esperaba 2 s con un `setTimeout` y escribía en consola sin producir archivo alguno.
        Una tarjeta sin productor se retira, no se rellena.
      -->
      <v-card-text data-testid="group-manager-report-retired">
        <v-alert type="info" variant="tonal" density="compact">
          Estas cifras no tienen un productor canónico y fueron retiradas en P13-V5A-R5. El
          backend no publica ningún reporte de group manager; los reportes con alcance
          canónico están disponibles en el Centro de Reportes Organizacional
          (Reportes › Organizacional).
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

// Store
const authStore = useAuthStore()

/**
 * Lo único que esta vista puede afirmar es la identidad del actor autenticado, que procede
 * de la sesión. El resto del estado del componente (reportData, los headers de la tabla de
 * supervisores, las instancias de Chart.js, los helpers de color/etiqueta y el exportador
 * simulado) se eliminó junto con los literales que describía: sin productor no hay nada que
 * formatear ni que colorear.
 */
const managerInfo = computed(() => ({
  name: authStore.user?.fullName || authStore.userName || 'Group Manager'
}))
</script>

<style scoped>
.group-manager-report {
  padding: 16px;
}
</style>
